import React, { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';

import { Box, Button, Heading, Text } from '@chakra-ui/react';
import { cancelOrder } from './api';

function CheckoutVoucherDepleted() {
  const { orderId, code } = useParams();

  useEffect(() => {
    const cancel = async (_orderId) => cancelOrder(_orderId);
    cancel(orderId);
  }, [orderId]);

  return (
    <Box>
      <Heading color='white' fontSize={'4xl'}>
       Errore nell'ordine
      </Heading>
      <Text my={5} color='white' fontSize={'3xl'}>
        Il voucher {code} inserito è stato già utilizzato.
        <br/>
        Il tuo ordine è stato annullato e nessun addebito è stato eseguito.
      </Text>
      <Button as={Link} to='/menu' my={50} size={'lg'}>
        Ritorna al menù
      </Button>
    </Box>
  );
}

export default CheckoutVoucherDepleted;
